import React, { useState } from 'react';
import { Select, MenuItem, Typography, FormControl, Box } from '@mui/material';
import {
  ChevronDown16Filled,
} from '@fluentui/react-icons';

const Dropdown = ({
  label,
  value,
  onChange,
  options,
  disabled = false,
  sx = {},
  boxSx = {}
}) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <Box width='100%' sx={{...boxSx}}>
      {label &&
      <Typography
        variant="body2"
        sx={{
          textAlign: 'left',
          color: isFocused ? 'var(--navyBlue-default)' : 'var(--black)',
          transition: 'color 0.2s ease-in-out',
          fontWeight: isFocused ? '600' : '500',
          marginBottom: 0.5,
        }}
      >
        {label}
      </Typography>}

      <FormControl fullWidth variant="outlined">
        <Select
          value={value}
          onChange={onChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          displayEmpty
          disabled={disabled}
          IconComponent={ChevronDown16Filled}
          MenuProps={{
            PaperProps: {
              sx: {
                boxShadow: 1,
              },
            },
          }}
          sx={{
            borderRadius: '10px',
            backgroundColor: 'var(--white)',
            fontSize: '1rem',
            height: '45px',
            '& fieldset': {
              borderColor: 'var(--gray-300)',
            },
            '&:hover fieldset': {
              borderColor: 'var(--gray-300) !important',
            },
            '&.Mui-focused fieldset': {
              borderColor: 'var(--navyBlue-default) !important',
            },
            '& .MuiOutlinedInput-input': {
              padding: '13px 13px',
            },
            '&.Mui-disabled': {
              backgroundColor: 'var(--gray-100)',
              color: 'var(--gray-300)',
              cursor: 'not-allowed',
              '& fieldset': {
                borderColor: 'var(--gray-300) !important',
              },
            },
            '& .MuiSelect-icon': {
              fontSize: '1.15rem',
              color: 'var(--gray-500)',
              paddingRight: '3px',
              paddingLeft: '3px',
            },
            ...sx,
          }}
        >
          {options.map((option) => (
            <MenuItem
              key={option.value}
              value={option.value}
              sx={{
                borderRadius: '8px',
                margin: 0.5,
                // '&:hover': {
                //   backgroundColor: 'var(--gray-100)',
                // },
                // '&.Mui-selected': {
                //   backgroundColor: 'var(--navyBlue-lightest) !important',
                // },
                // '&.Mui-selected:hover': {
                //   backgroundColor: 'var(--navyBlue-dark) !important',
                // },
              }}
            >
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default Dropdown;
